var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositionModerat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.91 191.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 114.16,
    width: 0.43,
    height: 74.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-95.4 72.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 151.2,
    width: 74.5,
    height: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-95.45 72.61) rotate(-45.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-115.21 129.68) rotate(-67.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-54.36 26.36) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-115.2 129.6) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-54.4 26.39) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-116.35 162.21) rotate(-79.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-78.14 48.49) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-116.36 162.06) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-78.09 48.43) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-108.34 100.87) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-29.15 10.87) rotate(-11.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.63,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-108.32 100.82) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-29.17 10.88) rotate(-11.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.84,189a37.55,37.55,0,1,1,37.55-37.55A37.58,37.58,0,0,1,39.84,189Zm0-70.2A32.66,32.66,0,1,0,72.5,151.41,32.69,32.69,0,0,0,39.84,118.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.88,151.41a4,4,0,1,1-4-4A4,4,0,0,1,43.88,151.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.84,191.26a39.85,39.85,0,1,1,39.85-39.85A39.89,39.89,0,0,1,39.84,191.26Zm0-74.5A34.66,34.66,0,1,0,74.5,151.41,34.68,34.68,0,0,0,39.84,116.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.59,
    y: 101.1,
    width: 71.74,
    height: 3.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "112.81 152.25 54.62 110.07 56.47 106.74 114.66 148.91 112.81 152.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.36,81.94a8,8,0,1,0,0,15.91,2.15,2.15,0,0,0,0-4.29h0a3.67,3.67,0,0,1,0-7.33v0H60.73l-22.3,65.38,3.47,1.18,23-66.56a3.15,3.15,0,0,0-.86-3.16,4.45,4.45,0,0,0-2.88-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.2,81.94H45.36a8,8,0,1,0,0,15.91,2.15,2.15,0,0,0,0-4.29h0a3.67,3.67,0,0,1,0-7.33v0H60.73L56.2,99.47h4.15l4.59-13.26a3.15,3.15,0,0,0-.86-3.16A4.45,4.45,0,0,0,61.2,81.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.36,97.85a2.15,2.15,0,0,0,0-4.29h0a3.67,3.67,0,0,1,0-7.33v0h5.87V81.94H45.36a8,8,0,1,0,0,15.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.14,75.59a1,1,0,0,0,.12-1.29c-.4-.87-1.45-2.62-4.81-2.5s-8.18,1-11.67.67-8.43-.29-10.8.36-3.06,1.9-2,2.33,4.16.54,7.67.62a23.09,23.09,0,0,1,7.42,1.4c1.79.58,2.09,1,3.63.81s3.8-1.65,5.83-2S147,75.85,147.14,75.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "111.08 152.18 114.55 153.36 139.34 73.98 135.13 73.98 111.08 152.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "115.89 161.99 115.78 161.13 164.8 154.59 164.91 155.45 115.89 161.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.15,
    y: 119.36,
    width: 1.3,
    height: 49.95,
    transform: "translate(-26.99 256.41) rotate(-79.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.82,147.58s-3.69,2.1-6.41,1.22a4,4,0,0,0-1.87-1.84h0c-.91-2.72,1.21-6.44,1.21-6.44l-3-.77h0l-3,.77s2.12,3.72,1.22,6.44h0a3.93,3.93,0,0,0-1.87,1.84c-2.72.88-6.41-1.22-6.41-1.22l-.77,2.95h0l.77,2.95s3.64-2.08,6.35-1.24a4,4,0,0,0,1.94,2c.82,2.71-1.24,6.32-1.24,6.32l3,.77h0l3-.77s-2.06-3.61-1.24-6.32a4,4,0,0,0,1.94-2c2.72-.84,6.36,1.24,6.36,1.24l.77-2.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.81,162.39a11.81,11.81,0,1,1,11.81-11.81A11.83,11.83,0,0,1,112.81,162.39Zm0-21.89a10.08,10.08,0,1,0,10.09,10.08A10.09,10.09,0,0,0,112.81,140.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.91,150.41a3.7,3.7,0,0,1-1.67,1,33.85,33.85,0,0,0-6.61,2.42c-2.27,1.21-6.3,3.25-6.3,3.25l-.78,3a41.14,41.14,0,0,1,3.9-1.56,59.38,59.38,0,0,0,7.23-2.85c2.1-1.07,3.94-2.25,4.64-2.34a6.49,6.49,0,0,0,1.69-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M97.57,158.63a2,2,0,0,1-2,2H90.47a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h5.06a2,2,0,0,1,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94.46,158.63A1.46,1.46,0,1,1,93,157.17,1.46,1.46,0,0,1,94.46,158.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115,150.58a2.21,2.21,0,1,1-2.21-2.21A2.21,2.21,0,0,1,115,150.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 114.16,
    width: 0.43,
    height: 74.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-58.72 161.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 151.2,
    width: 74.5,
    height: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-58.72 161.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-38.39 245.11) rotate(-67.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-45.04 73.77) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-38.4 245.08) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-45.07 73.85) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-14.59 285.19) rotate(-79.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-56.54 118.79) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-14.7 285.04) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-56.52 118.68) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-52.37 205.19) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-26.68 35.62) rotate(-11.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164.85,
    y: 114.16,
    width: 0.43,
    height: 74.5,
    transform: "translate(-52.39 205.12) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.82,
    y: 151.2,
    width: 74.5,
    height: 0.43,
    transform: "translate(-26.59 35.48) rotate(-11.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.07,189a37.55,37.55,0,1,1,37.54-37.55A37.58,37.58,0,0,1,165.07,189Zm0-70.2a32.66,32.66,0,1,0,32.66,32.65A32.69,32.69,0,0,0,165.07,118.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.1,151.41a4,4,0,1,1-4-4A4,4,0,0,1,169.1,151.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.07,191.26a39.85,39.85,0,1,1,39.84-39.85A39.89,39.89,0,0,1,165.07,191.26Zm0-74.5a34.66,34.66,0,1,0,34.66,34.65A34.69,34.69,0,0,0,165.07,116.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.19,149l-36.06-46.27-2.74,2.65,35.07,45a2.65,2.65,0,0,0-.16.89,2.61,2.61,0,1,0,3.89-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M124.56,31.87a61.34,61.34,0,0,1,6.31,4A58.39,58.39,0,0,1,138,42.62c2.11,2.39,3.8,5.14,5.69,7.73,1.41,1.93,2.87,3.83,4.25,5.79A14.8,14.8,0,0,1,150.1,70c-.68,2.11-1.33,3.72-3.28,5.17-6.29,4.68-13.32,8.44-18.6,14.37-2.35,2.64-5.34,4.17-8.23,6a69.21,69.21,0,0,0-7.15,5.56,20.7,20.7,0,0,0-2.33,2.82c1.28,1.07,2.8,2.18,4.13,3.48,2.92,2.85,6.1,5.54,8.45,8.82,1.14,1.58,1.86,3.6,3.38,5,1.08,1,2.43,1.69,3.48,2.7,1.67,1.62,3.18,3.4,4.79,5.08a5.36,5.36,0,0,0,1.5,1.15c3.27,1.53,4.73,4.85,7.16,7.2,1.15,1.12,2.35,2.8,1.49,4.62a6.63,6.63,0,0,1-5.07,3.85,5.52,5.52,0,0,0-2.25.84c-2.56,1.84-4.94,4-7.6,5.63a13.23,13.23,0,0,1-5.9,2.3c-1.25.07-2.71-1.59-3.83-2.71-.28-.29.21-1.61.62-2.29,1.52-2.52,3.14-5,4.76-7.44a4.68,4.68,0,0,0-.15-5.62,52.45,52.45,0,0,1-3.34-5.51,13.55,13.55,0,0,0-5-5.09l-13-8.38a7.23,7.23,0,0,0-.29,1.71c.14,3.16.29,6.31.56,9.46.37,4.26.72,8.54,1.33,12.77.25,1.78,1,3.48,3.26,3.9,1.44.27,1.56,1.58,1.47,2.72a24.36,24.36,0,0,1-.76,4.49,2.5,2.5,0,0,1-1.42,1.3,42.56,42.56,0,0,1-4.89,1.53,25.66,25.66,0,0,0-9.54,4.08,8.86,8.86,0,0,1-8.16,1.34c-2.63-.88-5-2.67-7.33-4.25-.44-.3-.47-1.53-.33-2.26.06-.36,1-.84,1.46-.79,2.62.26,4.61-1,6.44-2.56a44.71,44.71,0,0,0,6.23-5.9c1-1.32,1-3.43,1.52-5.17a4.53,4.53,0,0,1,.73-1.11c.18-.28.53-.58.51-.85-.13-1.81-.34-3.61-.54-5.41,0-.18-.19-.36-.18-.54.26-4.73-2-8.85-3.11-13.26-.88-3.62-1.59-7.29-2.21-11a23.84,23.84,0,0,0-3.36-9.49c-1.29-1.94-.61-7.28,1.08-8.83,2.18-2,4.23-4.14,6.39-6.16a28.54,28.54,0,0,1,2.71-2c.4-.3.81-.59,1.18-.93,4.24-3.85,8.47-7.73,12.73-11.56a9.52,9.52,0,0,1,2.09-1.3c1.91-1,3-2.09,2.31-4.56-.42-1.44-1-2.13-2.4-2a4.34,4.34,0,0,1-4.29-1.72c-.59-.79-2.06-1.07-3.19-1.28s-2.17-.39-2.78-1.61c-.72-1.42-2.16-1.28-3.37-1a5.08,5.08,0,0,1-4.78-1c-1.26-1.07-2.31-.58-2.71.92C88.79,61.58,84.32,66.5,82,72.53c-2.17,5.53-6.77,9.22-11.54,12.72-5.19,3.81-9.9,8.27-15,12.24-1.75,1.37-4,2.13-6,3.09a1.44,1.44,0,0,1-1.21-.31c-1.93-1.56-3.87-3.12-5.68-4.82-.37-.35-.33-1.3-.27-2,.16-1.76,2.26.36,2.41-1.4,0-.51,1.21.77.88.58-.69-.38-.4.93-1.19.73-.47-.79-.47-.5,0,0,1.56,1.68-.4-1.27,0,0-1.53,1.61,2.92-1.51,1-.22,1.24-2.62-.19,1.12,0,0-.18-1.91.15,1.91,0,0,.92,1.92.06,1.43,0,0-.09-2-1.64-1.27.24-.51a10.54,10.54,0,0,1-2.94.24c2.06-1.24,5.16-2.2,6.19-3A3,3,0,0,1,51.23,89c1.86.17,2.42-1,4.23-1.29a23.79,23.79,0,0,0,3.26-3.1c4-4,3.26-3,4.7-5.12,3.09-4.52,6.33-9,9.16-13.65,1.57-2.6,2.44-5.62,3.62-8.46.12-.29.09-.68.28-.9,2.61-3.08,2.26-6.72,2.13-10.37a15.5,15.5,0,0,1,.69-4.67c.48-1.65,0-2.52-1.57-3a66.81,66.81,0,0,1-6.73-2c-1.16-.45-1.88-1.63-3.51-1.2-3.77,1-3.78.87-5.76-2.63-.66-1.16-1.47-2.24-2.18-3.32C57,29.51,57,29.28,57,26.91a20.88,20.88,0,0,0-.84-6.12,1.6,1.6,0,0,0-.77-.77c-.65-.34-1.76-.43-1.93-.9a6.93,6.93,0,0,1-.3-3.32,46.52,46.52,0,0,1,1.44-5.51c1-3.13,3.34-4.53,6.24-5.84C65.62,2.3,70.66,1.21,75.69,0a1.85,1.85,0,0,1,.71.13l.25.55a12.43,12.43,0,0,1-2.31,1.15c-2.76.71-5.57,1.22-8.32,2a23.71,23.71,0,0,0-4.38,1.79,2.15,2.15,0,0,0-.9,1.75L61.92,7,68,5.21l3.78-1.16c.42-.13,1-.47,1.26-.32,2.14,1.2,3-.59,4.13-1.73a2.85,2.85,0,0,1-.41,4c-2.11,1.77-4.13,3.65-6.19,5.48h0l-1,1.62c.5.2.9-.18,1.33-.44,1.08-.67.55-2,2.69-2.06-.27-1.07,3.41,1.18,3.21.41l-3.61-.46C74.82,9.27,76,8.38,77.09,7.41c.61-.54,1.09-1.22,1.67-1.79a1.49,1.49,0,0,1,.91-.43.88.88,0,0,1,.59.62c.18,2,.18,4,.49,6,.26,1.6.9,3.14,1.31,4.73a24.67,24.67,0,0,1,1.08,4.88c.09,2.09,1,3.38,3.14,3.35,1.89,0,3.79-.31,5.68-.34a50.75,50.75,0,0,1,14.43,2c3.53,1,7.11,1.75,10.67,2.62a6.13,6.13,0,0,1,.72.25M57.83,14.69l.51.44a57.18,57.18,0,0,1,3.82-4.51,54.58,54.58,0,0,1,4.55-3.57C62.79,8.55,59.56,10.8,57.83,14.69ZM98.44,155.52l0-.69-10.19-1.34,0,.3Zm6.78-8.93-.42.08a4.54,4.54,0,0,0,.32,1.43,8,8,0,0,0,1.51,1.68,3.6,3.6,0,0,0,1.18.43c0-.44.08-1-.16-1.3A31.37,31.37,0,0,0,105.22,146.59Zm30.21-16.19L135,131l3.79,2.51.35-.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "112.81 147.22 116.29 148.4 135.25 86.04 130.41 88.15 112.81 147.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.85,188.74A37.55,37.55,0,1,1,202.4,151.2,37.58,37.58,0,0,1,164.85,188.74Zm0-70.2a32.66,32.66,0,1,0,32.66,32.66A32.7,32.7,0,0,0,164.85,118.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.85,191A39.85,39.85,0,1,1,204.7,151.2,39.88,39.88,0,0,1,164.85,191Zm0-74.5a34.66,34.66,0,1,0,34.66,34.66A34.69,34.69,0,0,0,164.85,116.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.15,149l-36.06-46.27-2.74,2.65,35.07,45a2.65,2.65,0,0,0-.16.89,2.61,2.61,0,1,0,3.89-2.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "126.36 104.92 102.04 104.92 104.8 101.1 126.36 101.1 126.36 104.92"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionModerat);
export default __webpack_public_path__ + "static/media/position-moderat.92e0e509cd2b0fd5315276ec3ea8d715.svg";
export { ForwardRef as ReactComponent };